import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import './SkillGeoJobMatches.scss';
import SkillGeoJobMatchRow from './SkillGeoJobMatchRow';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import { PRICING_TYPE } from '../SkillGeoDifferentialReducer';

export class SkillGeoJobMatches extends React.Component {
  static propTypes = {
    jobMatches: arrayOf(
      shape({
        matchId: number,
        surveyJobCode: string,
        surveyCode: string,
        slotJobCode: string,
        slotJobCodeKey: string,
        jobScope: string,
        surveyYear: number,
        surveyTitle: string,
        jobTitle: string,
        geo: number,
        adj: number
      })
    ),
    selectedJobMatches: arrayOf(number),
    setSelectedJobMatches: func,
    pricingType: string
  };

  constructor(props) {
    super(props);

    this.toggleSelectAll = this.toggleSelectAll.bind(this);
  }

  render() {
    const { jobMatches, selectedJobMatches, pricingType } = this.props;
    return (
      <React.Fragment>
        <div className="header__row" onClick={this.toggleSelectAll}>
          <div className="job-match-details__column">
            <div className="select-all__checkbox">
              <CheckboxInput checked={selectedJobMatches.length === jobMatches.length} onClick={this.toggleSelectAll} />
            </div>
            <div className="job-match-column__header">
              {pricingType === PRICING_TYPE.PRICED && <span>Survey </span>}
              {pricingType === PRICING_TYPE.SLOTTED && <span>Slotted </span>}
              <span>Job Matches</span>
            </div>
          </div>
          <div className="job-match-geo__column">Geo Adj</div>
          <div className="job-match-skill__column">Skill Adj</div>
        </div>
        {this.renderJobMatchSelections()}
      </React.Fragment>
    );
  }

  renderJobMatchSelections() {
    const { jobMatches, selectedJobMatches, setSelectedJobMatches, pricingType } = this.props;
    const matchSelections = [];
    jobMatches
      .sort((a, b) => {
        if (pricingType === PRICING_TYPE.PRICED) {
          if (a.surveyCode < b.surveyCode) {
            return -1;
          }
          if (a.surveyCode > b.surveyCode) {
            return 1;
          }
          if (a.surveyJobCode < b.surveyJobCode) {
            return -1;
          }
          if (a.surveyJobCode > b.surveyJobCode) {
            return 1;
          }
        } else if (pricingType === PRICING_TYPE.SLOTTED) {
          if (a.slotJobCode < b.slotJobCode) {
            return -1;
          }
          if (a.slotJobCode > b.slotJobCode) {
            return 1;
          }
          if (a.slotJobCodeKey < b.slotJobCodeKey) {
            return -1;
          }
          if (a.slotJobCodeKey > b.slotJobCodeKey) {
            return 1;
          }
        }
        return 0;
      })
      .forEach(match => {
        matchSelections.push(
          <SkillGeoJobMatchRow
            key={match.matchId}
            selectedJobMatches={selectedJobMatches}
            pricingType={pricingType}
            jobMatch={match}
            defaultChecked={selectedJobMatches.includes(match.matchId)}
            setSelectedJobMatches={setSelectedJobMatches}
          />
        );
      });
    return matchSelections;
  }

  toggleSelectAll() {
    const { jobMatches, selectedJobMatches, setSelectedJobMatches } = this.props;
    let newSelectedJobMatches = [];
    if (selectedJobMatches.length === 0) {
      newSelectedJobMatches = jobMatches.map(match => match.matchId);
    }
    setSelectedJobMatches(newSelectedJobMatches);
  }
}

export default SkillGeoJobMatches;
